export default __webpack_public_path__ + "static/media/collect-open.9dd3a0db.webp";